// extracted by css-extract-rspack-plugin
export default {"clickableRow":"ListNotAdmin__clickableRow--WxGkm","list":"ListNotAdmin__list--nbi3N"};